import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import { useLang } from "../../../Hooks";
import { ReportHeader } from "../Shared/Components/ReportHeader";
import { ReportToolbar } from "../Shared/Components/ReportToolbar";
import { reportToolbarStyles } from "../Shared/Styles/reportToolbarStyles";
import { TrialBalanceActions } from "./Components/TrialBalanceActions";
import { TrialBalanceExportModal } from "./Components/TrialBalanceExportModal";
import { TrialBalanceFilters } from "./Components/TrialBalanceFilters";
import { TrialBalanceTable } from "./Components/TrialBalanceTable";
import { useTrialBalanceData } from "./hooks/useTrialBalanceData";

export default function TrialBalance() {
  const { texts } = useLang();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    branches,
    fetchBranches,
    filters,
    isExporting,
    isLoadingBranches,
    isLoadingReport,
    reportData,
    handleApplyCustomRange,
    handleApplySettings,
    handleDateRangeSelect,
    handleExport,
  } = useTrialBalanceData();

  return (
    <>
      <TrialBalanceExportModal
        initialFrom={filters.from_date}
        initialTo={filters.to_date}
        isOpen={isOpen}
        onApplyCustomRange={handleApplyCustomRange}
        onClose={onClose}
      />
      <Flex {...reportToolbarStyles.headerRow}>
        <ReportHeader
          title={texts.reports?.trialBalance || "Trial Balance"}
          subtitle={texts.reports?.financialOverview || "Financial overview"}
        />
        <ReportToolbar>
          <TrialBalanceFilters
            branches={branches}
            fetchBranches={fetchBranches}
            filters={filters}
            isLoadingBranches={isLoadingBranches}
            onApplySettings={handleApplySettings}
            onOpenCustomRange={onOpen}
            onSelectRange={handleDateRangeSelect}
          />
          <TrialBalanceActions isExporting={isExporting} onExport={handleExport} />
        </ReportToolbar>
      </Flex>
      {isLoadingReport ? (
        <Flex justify="center" align="center" h="400px">
          <Spinner />
        </Flex>
      ) : (
        <TrialBalanceTable data={reportData} />
      )}
    </>
  );
}
